import React from 'react';
import {MasterLayout} from 'layout';
import {BoSungThongTinChuyenDon} from "modules/bo-sung-thong-tin";

class BoSungChuyenDonPage extends React.Component {

  render() {
    return (
      <MasterLayout routerName={this.props.route.name}>
        <BoSungThongTinChuyenDon params={this.props.params} lanhDao={true}/>
      </MasterLayout>
    );
  }
}

export default BoSungChuyenDonPage;


// WEBPACK FOOTER //
// ./src/components/pages/bo-sung-thong-tin/BoSungChuyenDonPage.jsx